<template>
    <div class="findEmail" id="findEmail">
        <div class="container">
            <form class="py-5">
                <GoodWizard ref="wizard" :steps="steps" :onNext="nextClicked" :onBack="backClicked">
                    <div slot="page1" class="slot mx-auto">
                        <h4 class="text-center">아이디 찾기</h4>

                        <div class="my-5">
                            <p>가입시 입력하신 휴대전화번호를 입력해주세요.</p>

                            <div class="form-group input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">핸드폰 번호</span>
                                </div>
                                <input v-model="member.phoneNumber"  @keyup="autoHypen(member.phoneNumber)" ref="phoneNumber" class="form-control" placeholder="010-xxxx-xxxx" type="text" value="">
                            </div>
                        </div>
                    </div>

                    <div slot="page2" class="slot mx-auto">
                        <h4 class="text-center">핸드폰 번호 인증</h4>

                        <div class="my-5">
                            문자가 발송되었습니다. 문자로 전송된 인증코드를 입력해주세요.
                        </div>

                        <div class="form-group input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text"> 인증코드</span>
                            </div>
                            <input v-model="smsAuthCode" type="text">
                        </div>
                        <div class="form-group input-group">
                            <button type="button" class="btn btn-danger btn-block" v-on:click="phoneAuthorization()">
                                인증 확인
                            </button>
                        </div>

                    </div>
                    <div slot="page3" class="slot mx-auto">
                        <h4 class="text-center">아이디 확인</h4>

                        <div v-if="authorized" class="my-5">
                            가입시 입력하신 아이디(이메일)은 {{member.email}} 입니다.
                            <router-link :to="{name : 'login', params : {email:member.email}}"> 로그인 하러 가기</router-link>
                        </div>

                    </div>
                </GoodWizard>
            </form>
        </div>
    </div>
</template>
<script>
    import { GoodWizard } from 'vue-good-wizard';
    export default {
        name: 'forgotEmail',
        components: {
          GoodWizard
        },
        data() {
            return {
                authorized:false,
                email:'',
                steps: [
                    {
                        label: '핸드폰 번호 입력',
                        slot: 'page1',
                    },
                    {
                        label: '인증코드(문자) 확인',
                        slot: 'page2',
                    },
                    {
                        label: '아이디(이메일) 확인',
                        slot: 'page3',
                        options: {
                            nextDisabled: true, // control whether next is disabled or not
                        },
                    }
                ],
                member: {
                    email:'',
                    password:'',
                    joinAuthCode:''
                },
                smsAuthCode:''
            };
        },
        methods: {
            nextClicked(currentPage) {
                let canNext = false;
                if(currentPage == 0) { // 이메일 입력
                    if(this.phoneNumber != '') {
                        this.sendAuthSms();
                    } else {
                        this.$root.$children[0].commonDialog('아이디 찾기', '휴대폰 번호를 입력해주세요.');
                        //this.$refs.email.focus();
                        canNext=false;
                    }
                } else if(currentPage == 1) {
                    if(this.authorized) canNext=true;
                    else canNext=false;
                }
                return canNext; //return false if you want to prevent moving to next page
            },
            backClicked(currentPage) {
                //console.log('back clicked', currentPage);
                return true; //return false if you want to prevent moving to previous page
            },
            sendAuthSms() {
                this.isSmsSended = true

                let me = this;
                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/phone/${this.member.phoneNumber}`)
                    .then(function (res) {
                        if (res.data) {
                            me.$root.$children[0].commonDialog('아이디 찾기', '입력하신 번호로 인증 문자가 발송 되었습니다. ')
                            me.$refs['wizard'].goTo(1);
                        } else {
                            me.$root.$children[0].commonDialog('아이디 찾기', '가입되지 않은 연락처입니다.')
                        }
                    }).catch(function (error) {
                    //console.log(error);
                    alert(error);
                });
            },

            phoneAuthorization() {
                let me = this;

                if (!this.smsAuthCode) {
                    this.$root.$children[0].commonDialog('인증번호를 입력해주세요.')
                    return;
                }

                this.axios.put(process.env.VUE_APP_MEMBER_API_URL + `/phone/${this.member.phoneNumber}/${this.smsAuthCode}`)
                    .then(function (res) {
                        if(res.data.isPhoneAuthorized) {
                            me.member.email = res.data.email;
                            me.$refs['wizard'].goTo(2);
                            me.authorized = true;
                        } else
                            me.$root.$children[0].commonDialog('본인인증','인증에 실패하였습니다. 다시 시도해주세요. (최대5회) ')
                    }).catch(function (error) {
                    console.log(error);
                    //alert(' 에러');
                });
            },
            autoHypen(num) {

                let number = num.replace(/[^0-9]/g, "");
                let phone = "";

                if(number.length < 4) {
                    phone = number;
                } else if(number.length < 7) {
                    phone += number.substr(0, 3);
                    phone += "-";
                    phone += number.substr(3);
                } else if(number.length < 11) {
                    phone += number.substr(0, 3);
                    phone += "-";
                    phone += number.substr(3, 3);
                    phone += "-";
                    phone += number.substr(6);
                } else {
                    phone += number.substr(0, 3);
                    phone += "-";
                    phone += number.substr(3, 4);
                    phone += "-";
                    phone += number.substr(7);
                }
                this.member.phoneNumber = phone;
            },


        },

        computed: {},
        mounted() {
        },

    };
</script>
<style>
    .divider-text span {
        padding: 7px;
        font-size: 12px;
        position: relative;
        z-index: 2;
    }

    .slot {
        max-width:450px;

    }
</style>